import { RefObject, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../store';
import { ItemType } from '../types';
import useObserver from './useObserver';
import useScreenHeight from './useScreenHeight';

export const useCalendarHeightContainer = (containerParent: RefObject<HTMLDivElement>) => {
    const screenHeight = useScreenHeight();
    const filteredItems = useSelector<RootState, ItemType[]>((state) => state.calendar.filteredItems);
    const [heightContainer, setHeightContainer] = useState(0);

    const calcAndSetHeight = () => {
        setHeightContainer(screenHeight - (containerParent?.current?.getBoundingClientRect().top || 0));
    };

    useObserver(calcAndSetHeight, containerParent.current, filteredItems);

    useEffect(() => {
        calcAndSetHeight();
    }, [containerParent, screenHeight]);

    return heightContainer;
};
